import React, { useState } from "react";
import style from "css/hotdesking.module.css";
import { ConfigProvider, Radio } from "antd";
import { ReactComponent as PersonIcon } from "asset/hotdesking/person.svg";
import { ReactComponent as ScheduleIcon } from "asset/hotdesking/schedule.svg";
import TodayMenu from "./TodayMenu";
import UserMenu from "./UserMenu";
import Loading from "./Loading";
import HotdeskingConfig from "../Config";
import { useTranslation } from "react-i18next";

function Menu({
  data,
  onCancel,
  onCheckIn,
  onCheckOut,
  onExtend,
  onShare,
  onShowBook,
  onShowResource,
  onBook,
  onError,
  date,
  time,
  isLoading,
}) {
  const [viewType, setViewType] = useState(HotdeskingConfig.menuType.today);
  const contentRender = () => {
    switch (viewType) {
      case HotdeskingConfig.menuType.today:
        return (
          <TodayMenu
            data={data}
            date={date}
            time={time}
            onCancel={onCancel}
            onCheckIn={onCheckIn}
            onCheckOut={onCheckOut}
            onExtend={onExtend}
            onShare={onShare}
            onShowBook={onShowBook}
            onShowResource={onShowResource}
            onBook={onBook}
            onError={onError}
          />
        );
      case HotdeskingConfig.menuType.user:
        return <UserMenu onShowBook={onShowBook} />;
      default:
        return <></>;
    }
  };
  return (
    <section className={style.menu}>
      {isLoading ? (
        <Loading />
      ) : (
        <>
          <ViewTypeButton viewType={viewType} setViewType={setViewType} />
          {contentRender()}
        </>
      )}
    </section>
  );
}

export default Menu;

function ViewTypeButton({ viewType, setViewType }) {
  const { t } = useTranslation();
  const onChangeType = (value) => {
    switch (value) {
      case HotdeskingConfig.menuType.today:
        setViewType(value);
        break;
      case HotdeskingConfig.menuType.user:
        setViewType(value);
        break;
      default:
        break;
    }
  };
  return (
    <ConfigProvider
      theme={{
        components: {
          Radio: {
            buttonBg: "#fff !important",
            buttonColor: "#555555",
            buttonSolidCheckedBg: "#000 !important",
            buttonSolidCheckedColor: "#d5fb55 !important",
          },
        },
      }}
    >
      <Radio.Group
        className={style.menu_type}
        optionType="button"
        buttonStyle="solid"
        value={viewType}
        onChange={(e) => onChangeType(e.target.value)}
      >
        <Radio value={HotdeskingConfig.menuType.today}>
          <ScheduleIcon
            className={
              viewType === HotdeskingConfig.menuType.today
                ? `${style.type_icon} ${style.active}`
                : style.type_icon
            }
          />
          <p>Today</p>
        </Radio>
        <Radio value={HotdeskingConfig.menuType.user}>
          <PersonIcon
            className={
              viewType === HotdeskingConfig.menuType.user
                ? `${style.type_icon} ${style.active}`
                : style.type_icon
            }
          />
          <p>{t("HOTDESKING.MENU.TEAM.TITLE")}</p>
        </Radio>
      </Radio.Group>
    </ConfigProvider>
  );
}
